import { useNavigate, useLocation, useParams } from "react-router-dom"
import { Box, Button } from "@mui/material"

function SpecialistDetailSidebar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { userId } = useParams()

  const menuItems = [
    { label: "Details", path: `/specialist/detail/${userId}` },
    { label: "Members", path: `/specialist/detail/${userId}/members` },
    {
      label: "Appointments",
      path: `/specialist/detail/${userId}/appointments`,
    },
  ]

  return (
    <Box
      sx={{
        p: 2,
        top: 20,
        width: 250,
        bgcolor: "white",
        overflow: "auto",
        position: "sticky",
        borderRadius: "12px",
        border: "1px solid #00000012",
        display: { xs: "none", xl: "block" }
      }}
    >

      {menuItems.map((item, i) => (
        <Button
          key={i}
          fullWidth
          onClick={() => navigate(item.path)}
          variant={
            location.pathname === item.path
              ? "activeSidebarMenu"
              : "sidebarMenu"
          }
          sx={{ justifyContent: "flex-start", mb: 1 }}
        >
          {item.label}
        </Button>
      ))}

    </Box>
  )
}

export default SpecialistDetailSidebar